import React, { useState } from 'react';
import { useSelector } from 'react-redux';

import BrandRadioGroup from './BrandRadioGroup';
import BrandDialog from '../../Brand/BrandDialog';

import {
    Button, Box, FormGroup, Alert, Accordion, AccordionSummary, AccordionDetails, Typography
} from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

const ProductBrand = ({ brand, setProdValues }) => {
    const { brands } = useSelector(state => state.category);
    const [open, setOpen] = useState(false);

    return (
        <>
            <Accordion defaultExpanded sx={{ boxShadow: '0 2px 4px 2px rgb(0 0 0 / 20%)' }}>
                <AccordionSummary
                    sx={{
                        '&.Mui-expanded': {
                            borderBottom: '1px solid #E5E5E5'
                        },
                    }}
                    expandIcon={<ExpandMoreIcon />}
                >
                    <Typography>Marca</Typography>
                </AccordionSummary>
                <AccordionDetails>
                    <Box sx={{ my: 2 }}>
                        <Button
                            variant="outlined"
                            sx={{ textTransform: 'none' }}
                            startIcon={<AddIcon fontSize="inherit" />}
                            onClick={() => setOpen(!open)}
                        >
                            Agregar nueva marca
                        </Button>
                    </Box>

                    <FormGroup>
                        {
                            brands.length <= 0 ?
                                <Alert severity="info">
                                    Añada marcas de producto
                                </Alert>
                                :
                                <BrandRadioGroup
                                    brand={brand}
                                    setProdValues={setProdValues}
                                />
                        }
                    </FormGroup>
                </AccordionDetails>
            </Accordion>

            <BrandDialog
                open={open}
                setOpen={setOpen}
            />
        </>
    );
};

export default ProductBrand;